import useSystemInfo from "hooks/useSystemStore";
const useSystemDetails = () => {
  const { data } = useSystemInfo();
  return data;
};
export default useSystemDetails;
